module.exports = __webpack_public_path__ + "static/a-prayer-for-owen-meany-e62c276e86922732b8d42e6fe414d83c.jpg";